import React, { useEffect, useRef } from 'react';
import { Box, ButtonLink, Inline, Text3, skinVars } from '@telefonica/mistica';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { hideSnackbar } from '../../utils/store/features/user';
import './index.scss';
import { isDesktop } from 'react-device-detect';
import navigateParams from '../../utils/navigation/navigateParams';
import { isWebviewAndroid, isWebviewIOS } from '../../utils/navigation/controlDevices';

export type ISnackbarMessageData = {
    url?: string;
    timeout?: number;
};

export const SnackbarMessage: React.FC<ISnackbarMessageData> = ({ url, timeout }: ISnackbarMessageData) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const snackbar = useRef<HTMLDivElement>(null);
    const intervalSnackbar = useRef<number>();
    const intervalAnimation = useRef<number>();
    const intervalHideSnackbar = useRef<number>(10300);

    useEffect(() => {
        if (timeout) intervalHideSnackbar.current = timeout!;

        intervalAnimation.current = window.setTimeout(() => {
            snackbar.current?.classList.add('hide');
        }, 10000);
        intervalSnackbar.current = window.setTimeout(() => {
            dispatch(hideSnackbar());
            if (url?.length) {
                if (isWebviewAndroid || isWebviewIOS) {
                    navigate(url!);
                }
            }
        }, intervalHideSnackbar.current);
        () => {
            window.clearTimeout(intervalAnimation.current);
            window.clearTimeout(intervalSnackbar.current);
        };
    }, []);

    return (
        <div
            ref={snackbar}
            className='c-snackbar'
            style={{
                background: skinVars.colors.feedbackInfoBackground,
                animation: `${isDesktop ? 'fadeInDesktop' : 'fadeInMobile'} .3s ease-in-out forwards`,
            }}
        >
            <Box padding={12}>
                <Inline space={8} alignItems='center'>
                    <Text3 color={skinVars.colors.textPrimaryInverse} regular>
                        {t('informationUserLight')}
                    </Text3>
                    <ButtonLink
                        onPress={() => {
                            dispatch(hideSnackbar());
                            window.clearTimeout(intervalSnackbar.current);
                            window.clearTimeout(intervalAnimation.current);
                            if (navigateParams('navigation-light-titular', '', {}, '', '')) {
                                navigate('/logout');
                            }
                        }}
                    >
                        {t('login')}
                    </ButtonLink>
                </Inline>
            </Box>
        </div>
    );
};

export default SnackbarMessage;
